export default __webpack_public_path__ + "static/media/secondIconRight.97672eae.svg";